import React from "react";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Grid, Link } from "@mui/material";
import { Controller } from "react-hook-form";
import WelcomeTitle from "../common/WelcomeTitle";
import { useStyles } from "./Login.page.style";
import { LoadingButton } from "@mui/lab";

const LoginComponent = (props) => {
	const {
		register,
		handleSubmit,
		onSubmit,
		control,
		errors,
		handleClickShowPassword,
		handleMouseDownPassword,
		showPassword,
		loginRemainTime,
	} = props;
	const classes = useStyles();

	return (
		<form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
			<Grid container direction={"column"} className={classes.loginFormContainer}>
				<WelcomeTitle />
				<Grid item container direction={"column"} className={classes.loginInputBox}>
					<Grid item className={classes.loginFont}>
						LOGIN
					</Grid>
					<Grid item className={classes.LoginInputWrapper}>
						<FormControl fullWidth>
							<FormLabel htmlFor="email" className={classes.blackColor}>
								Email
							</FormLabel>
							<Controller
								render={({ field }) => (
									<TextField
										{...field}
										{...register("email")}
										error={!!errors?.email}
										helperText={errors?.email?.message}
										variant="standard"
										InputProps={{
											className: classes.inputStyle,
										}}
										inputProps={{ maxLength: 128 }}
									/>
								)}
								id={"email"}
								name="email"
								control={control}
								rules={{
									required: true,
								}}
								fullWidth={true}
							/>
						</FormControl>
					</Grid>
					<Grid item className={classes.loginPwdInputWrapper}>
						<FormControl fullWidth>
							<FormLabel htmlFor="password" className={classes.blackColor}>
								Password
							</FormLabel>
							<Controller
								render={({ field }) => (
									<TextField
										{...field}
										type={showPassword ? "text" : "password"}
										error={!!errors.pwd}
										helperText={errors.pwd?.message}
										style={{ height: "30px" }}
										variant="standard"
										InputProps={{
											className: classes.inputStyle,
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														style={{ color: "black" }}
														size="large"
													>
														{showPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											),
										}}
										inputProps={{
											maxLength: 48,
											style: {
												fontFamily: showPassword || "text-security-disc",
											},
										}}
									/>
								)}
								control={control}
								rules={{
									required: true,
								}}
								id="pwd"
								name="pwd"
							/>
						</FormControl>
					</Grid>

					<Grid item container className={classes.LoginBtnWrapper}>
						<Grid item>
							<FormControl>
								<LoadingButton
									type="submit"
									variant="contained"
									color="primary"
									style={{
										textTransform: "none",
										fontFamily: "Quicksand-SemiBold",
										fontSize: 16,
										width: 100,
									}}
									loading={loginRemainTime > 0}
									disabled={loginRemainTime > 0}
								>
									Login
									{/* {loginRemainTime > 0 ? <CircularProgress size={16} /> : null} */}
								</LoadingButton>
							</FormControl>
						</Grid>
						<Grid item className={classes.forgetPwdWrapper}>
							<Link href={"/forgotPswSendEmail"} className={classes.forgetPwd}>
								Forget Password?
							</Link>
						</Grid>
					</Grid>
				</Grid>
				<Grid item container className={classes.signupNow}>
					Don't have an account?&nbsp;
					<Link href={"/signup"} className={classes.signupLink}>
						Sign up now
					</Link>
				</Grid>
			</Grid>
		</form>
	);
};

export default LoginComponent;
